import { environment } from '@env/environment';

export const normalizeIgvPorcentaje = (value: unknown): number => {
  const parsed = toNumber(value, 0.18);
  if (environment.igvOptions.includes(parsed)) return parsed;
  return 0.18;
};

export const formatIgvLabel = (igvPorcentaje: number): string => {
  const value = (igvPorcentaje * 100).toFixed(2);
  return value.replace(/\.00$/, '').replace(/0$/, '');
};

export const toNumber = (value: unknown, fallback = 0): number => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }
  return fallback;
};

export const formatFecha = (fecha: Date | string): string => {
  const date = new Date(fecha);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
};

export const safeIGV = (value: unknown): number => {
  const igv = toNumber(value, 0.18);
  return environment.igvOptions.includes(igv) ? igv : 0.18;
};

export const numeroALetras = (num: number): string => {
  const unidades = ['', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];

  const decenas = [
    'DIEZ',
    'ONCE',
    'DOCE',
    'TRECE',
    'CATORCE',
    'QUINCE',
    'DIECISEIS',
    'DIECISIETE',
    'DIECIOCHO',
    'DIECINUEVE',
  ];

  const decenas2 = [
    '',
    '',
    'VEINTE',
    'TREINTA',
    'CUARENTA',
    'CINCUENTA',
    'SESENTA',
    'SETENTA',
    'OCHENTA',
    'NOVENTA',
  ];

  const centenas = [
    '',
    'CIENTO',
    'DOSCIENTOS',
    'TRESCIENTOS',
    'CUATROCIENTOS',
    'QUINIENTOS',
    'SEISCIENTOS',
    'SETECIENTOS',
    'OCHOCIENTOS',
    'NOVECIENTOS',
  ];

  function convertir(n: number): string {
    if (n === 0) return 'CERO';
    if (n === 100) return 'CIEN';

    if (n < 10) return unidades[n];

    if (n < 20) return decenas[n - 10];

    if (n < 100) {
      const d = Math.floor(n / 10);
      const r = n % 10;
      return decenas2[d] + (r ? ' Y ' + unidades[r] : '');
    }

    if (n < 1000) {
      const c = Math.floor(n / 100);
      const r = n % 100;
      return centenas[c] + (r ? ' ' + convertir(r) : '');
    }

    if (n < 1000000) {
      const m = Math.floor(n / 1000);
      const r = n % 1000;
      return (m === 1 ? 'MIL' : convertir(m) + ' MIL') + (r ? ' ' + convertir(r) : '');
    }

    return '';
  }

  return convertir(Math.floor(num));
};
